// eslint-disable-next-line import/prefer-default-export
export const SET_VEHICLES_MODEL_LIST = 'SET_VEHICLES_MODEL_LIST';
export const SET_VEHICLES_MODEL_INFO = 'SET_VEHICLES_MODEL_INFO';
